import 'virtual:vite-plugin-sentry/sentry-config'
import { StrictMode, Suspense, lazy, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

import * as Sentry from '@sentry/react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import Providers from './components/Providers'
import App from './oakra/components/base-app'

import './i18n'
import './index.css'

Sentry.init({
    enabled: import.meta.env.MODE === 'production',
    dsn: __SENTRY_DSN__,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.zodErrorsIntegration(),
    ],
    release: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.release,
    dist: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.dist,
    tracesSampleRate: 1.0,
    environment: import.meta.env.MODE,
    normalizeDepth: 10,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})

const ReactQueryDevtoolsProduction = lazy(() =>
    import('@tanstack/react-query-devtools/production').then((d) => ({
        default: d.ReactQueryDevtools,
    }))
)

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        toggleDevTools: () => void
    }
}

function Oakra() {
    const [showDevtools, setShowDevtools] = useState(false)

    useEffect(() => {
        window.toggleDevTools = () => setShowDevtools((value) => !value)
    }, [])

    return (
        <StrictMode>
            <Sentry.ErrorBoundary fallback={<>An error has occurred</>}>
                <Providers>
                    <ReactQueryDevtools />
                    {showDevtools && (
                        <Suspense fallback={null}>
                            <ReactQueryDevtoolsProduction />
                        </Suspense>
                    )}
                    <App />
                </Providers>
            </Sentry.ErrorBoundary>
        </StrictMode>
    )
}

ReactDOM.render(<Oakra />, document.getElementById('root'))
